import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useCustomStyles = makeStyles()((theme) => ({
	offerDetails: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.xxsmall,
	},
	offerItem: {
		display: 'flex',
		alignItems: 'center',
		color: theme.body.foreground.color.default,
	},
	title: {
		overflow: 'hidden',
		whiteSpace: 'nowrap',
		textOverflow: 'ellipsis',
		marginLeft: theme.spacing.xxsmall,
	},
	boldTitle: {
		fontWeight: theme.weight.semibold,
		whiteSpace: 'pre-line',
		wordBreak: 'break-word',
		lineHeight: theme.icon.size.medium,
	},
}));
